<template>
  <div class="h-full">
    <Ad v-if="props.ads" mb-4 ad-slot="4143463098" />
    <div pb-1>
      <h2 text-lg md:text-xl text-stone-500 font-slab>What is my elevation?</h2>
      <p text-stone-400 text-sm>Learn more about where you are</p>
    </div>
    <div class="grid grid-auto-fit gap-7 lg:gap-5 py-lg pt-lg">
      <div class="flex flex-col text-stone-500 group">
        <NuxtLink @click="click" class="flex gap-2 font-semibold hover:text-black items-start pb-2 lg:pb-0" to="/">
          <div class="inline-block rounded-full p-1 bg-brand-orange group-hover:(scale-120 drop-shadow) transition">
            <div bg-white i-mdi-ruler></div>
          </div>
          What is my elevation?
        </NuxtLink>
        <div class="flex flex-col pl-8 pt-2 gap-4 lg:gap-2">
          <NuxtLink @click="click" to="/map" hover:text-black>Elevation map</NuxtLink>
          <NuxtLink @click="click" to="/peaks" hover:text-black>Nearby mountains</NuxtLink>
        </div>
      </div>
      <div class="flex flex-col text-stone-500 group">
        <NuxtLink
          @click="click"
          class="flex gap-2 font-semibold hover:text-black items-start"
          to="/how-fast-am-i-going"
        >
          <div
            class="items-start inline-block rounded-full p-1 bg-brand-red group-hover:(scale-120 drop-shadow) transition"
          >
            <div bg-white i-bi-speedometer></div>
          </div>
          How fast am I going?
        </NuxtLink>
      </div>
      <div class="flex flex-col text-stone-500 group">
        <NuxtLink
          @click="click"
          class="flex gap-2 font-semibold hover:text-black items-start pb-2 lg:pb-0"
          to="/what-is-my-address"
        >
          <div class="inline-block rounded-full p-1 bg-brand-blue group-hover:(scale-120 drop-shadow) transition">
            <div bg-white i-material-symbols-location-on-rounded></div>
          </div>
          Where am I?
        </NuxtLink>
        <div class="flex flex-col pl-8 pt-2 gap-4 lg:gap-2">
          <NuxtLink @click="click" to="/what-county-am-i-in" hover:text-black>County</NuxtLink>
          <NuxtLink @click="click" to="/what-township-am-i-in" hover:text-black>Township</NuxtLink>
          <NuxtLink @click="click" to="/what-school-district-am-i-in" hover:text-black>School District</NuxtLink>
          <NuxtLink @click="click" to="/what-neighborhood-am-i-in" hover:text-black>Neighborhood</NuxtLink>
          <NuxtLink @click="click" to="/what-is-my-zipcode" hover:text-black>ZIP code</NuxtLink>
          <!-- <NuxtLink @click="click"to="/address/city" hover:text-black>City</NuxtLink> -->
          <NuxtLink @click="click" to="/what-zone-am-i-in" hover:text-black>Plant hardiness zone </NuxtLink>
          <NuxtLink @click="click" to="/what-indigenous-territories-am-i-in" hover:text-black>Native lands</NuxtLink>
          <NuxtLink @click="click" to="/cicadas-near-me" hover:text-black
            >Cicadas
            <!-- <span class="bg-brand-blue text-white rounded uppercase font-semibold text-[0.7em] py-0.5 px-1"
              >New</span> -->
          </NuxtLink>
          <NuxtLink @click="click" to="/county-map" hover:text-black>County maps</NuxtLink>
        </div>
      </div>
      <div class="flex flex-col text-stone-500 group">
        <NuxtLink
          @click="click"
          class="flex gap-2 font-semibold hover:text-black items-start pb-2 lg:pb-0"
          to="/snow-totals"
        >
          <div class="inline-block rounded-full p-1 bg-brand-blue group-hover:(scale-120 drop-shadow) transition">
            <div bg-white i-ion-snow-sharp></div>
          </div>
          Snow Totals
        </NuxtLink>
        <div flex flex-col pl-8 pt-2 gap-4 lg:gap-2>
          <NuxtLink @click="click" to="/rain-totals" hover:text-black>Rain Totals</NuxtLink>
        </div>
      </div>
    </div>
    <hr />
    <div flex gap-2 text-stone-500 pt-5>
      <NuxtLink @click="click" class="after:(content-['•'] ml-2 text-stone-500)" to="/about" hover:text-black
        >About</NuxtLink
      >
      <NuxtLink @click="click" to="/about/privacy" hover:text-black>Privacy Policy</NuxtLink>
    </div>
    <Ad v-if="props.ads" m-4 ad-slot="7699564727" />
  </div>
</template>
<script setup>
const props = defineProps({
  ads: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(["click"]);
const click = () => {
  emit("click");
};
</script>
